import Vue from 'vue'
import { AuthFile } from '@/services/resources'

function setImgSrc (el, binding) {
  if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
    const imageUrl = binding.value
    return AuthFile.getFile(imageUrl)
      .then((response) => {
        return response.blob()
      })
      .then((blob) => {
        switch (el.tagName.toUpperCase()) {
          case 'OBJECT':
            el.data = window.URL.createObjectURL(blob)
            break
          case 'A':
            el.href = window.URL.createObjectURL(blob)
            break
          default:
            el.src = window.URL.createObjectURL(blob)
            break
        }
        return blob
      })
      .catch((error) => {
        el.src = '/static/img/imagem_nao_encontrada.png'
        return error
      })
  }
}

Vue.directive('auth-image', {
  bind: function (el, binding) {
    setImgSrc(el, binding)
      .catch((error) => {
        if (error.status === 404) {
          this.$toasted.global.error({ message: error.body.message })
        } else {
          this.$toasted.global.error({ message: error.statusText })
        }
      })
  }
})
